export default __webpack_public_path__ + "static/media/SteelGauge.15da8bbf.svg";